"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoaderCircle = LoaderCircle;
var react_1 = __importDefault(require("react"));
var styled_components_1 = require("styled-components");
var utils_1 = require("../utils");
var styled_1 = require("../styled");
/**
 * @component Renders a loader circle component with customizable text and styling.
 *
 * - The props object containing the following properties:
 * @prop {string} size: The size of the loader circle.
 * @prop {React.ReactNode} children: The content to be rendered inside the loader circle.
 * @prop {string} text: The text to be displayed in the loader circle.
 * @prop {string} debug: A boolean indicating whether to enable debug mode for the loader circle. Defaults to false. only for dev use
 * @prop {boolean} invert: A boolean indicating whether to invert the loader circle colors. Defaults to false.
 * @prop {boolean} isBlock: A boolean indicating whether the loader circle should be displayed as a block element. Defaults to true.
 * @prop {string} blockHeight: The height of the block element. Defaults to "100%".
 * @return {ReactElement} The rendered loader circle component.
 */
function LoaderCircle(_a) {
    var _b = _a.isBlock, isBlock = _b === void 0 ? true : _b, _c = _a.blockHeight, blockHeight = _c === void 0 ? '100%' : _c, L = _a.L, S = _a.S, M = _a.M, props = __rest(_a, ["isBlock", "blockHeight", "L", "S", "M"]);
    var size = L ? 'L' : S ? 'S' : 'M';
    var renderLoaderDiv = function () { return react_1.default.createElement(LoaderDiv, __assign({}, props, { isBlock: isBlock, size: size })); };
    return !isBlock ? (renderLoaderDiv()) : (react_1.default.createElement(styled_1.StyledLoaderOverlay, { blockHeight: blockHeight }, renderLoaderDiv()));
}
/**
 * @component Renders a loader Div component with customizable text and styling.
 *
 * - The props object containing the following properties:
 * @prop {string} size: The size of the loader div.
 * @prop {React.ReactNode} children: The content to be rendered inside the loader div.
 * @prop {string} text: The text to be displayed in the loader div.
 * @prop {string} debug: A boolean indicating whether to enable debug mode for the loader div. Defaults to false. only for dev use
 * @prop {boolean} invert: A boolean indicating whether to invert the loader div colors. Defaults to false.
 * @prop {boolean} isBlock: A boolean indicating whether the loader div should be displayed as a block element. Defaults to true.
 * @return {ReactElement} The rendered loader div component.
 */
var LoaderDiv = function (_a) {
    var size = _a.size, children = _a.children, _text = _a.text, debug = _a.debug, invert = _a.invert, isBlock = _a.isBlock;
    var theme = (0, styled_components_1.useTheme)();
    var text = _text || children;
    var _b = (0, utils_1.getTypoAndLoaderDimensions)(size), TypoComp = _b.TypoComp, trackThickness = _b.trackThickness, diameter = _b.diameter;
    return (react_1.default.createElement(styled_1.StyledLoaderWrapper, { isBlock: isBlock },
        react_1.default.createElement(styled_1.StyledCircLoader, { diameter: diameter, trackThickness: trackThickness, invert: invert }),
        (text || ((theme === null || theme === void 0 ? void 0 : theme.ENV) === "dev" && debug)) && (react_1.default.createElement(TypoComp, __assign({ invert: invert }, (size === 'L' ? { bold: true } : { semibold: true })), "".concat((theme === null || theme === void 0 ? void 0 : theme.ENV) === "dev" && debug ? "".concat(debug, " ") : "").concat(text || '')))));
};
